import helpers from "../../js/helpers";

/**
 * Currency action to set/change the current currency
 */
export const runSetCurrency = async (countryCode, options = {}) => {
    try {
        const {
            autoRedirect = true,
            rememberSelection = true,
            returnTo = '/'
        } = options;

        // Find the currency form - create it if it doesn't exist
        let form = document.querySelector('#currency-form');
        
        if (!form) {
            // Create the form dynamically if it doesn't exist
            form = document.createElement('form');
            form.id = 'currency-form';
            form.method = 'POST';
            form.action = '/localization';
            form.style.display = 'none';
            
            // Add required form fields
            const fields = [
                { name: 'form_type', value: 'localization' },
                { name: '_method', value: 'put' },
                { name: 'return_to', value: returnTo },
                { name: 'country_code', value: '' },
                { name: 'utf8', value: '✓' }
            ];

            fields.forEach(field => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = field.name;
                input.value = field.value;
                form.appendChild(input);
            });

            document.body.appendChild(form);
        }

        // Update form values
        const countryCodeInput = form.querySelector('input[name="country_code"]');
        const returnToInput = form.querySelector('input[name="return_to"]');
        
        if (countryCodeInput) {
            countryCodeInput.value = countryCode;
        }
        
        if (returnToInput) {
            returnToInput.value = returnTo;
        }

        // Store selection in localStorage if remember is enabled
        if (rememberSelection) {
            localStorage.setItem('preferred_currency', countryCode);
        }

        // Dispatch event before currency change
        const beforeChangeEvent = new CustomEvent('currency:beforeChange', {
            detail: {
                newCountryCode: countryCode,
                autoRedirect,
                rememberSelection
            }
        });
        
        window.dispatchEvent(beforeChangeEvent);

        if (autoRedirect) {
            // Use Shopify's captcha protection if available
            if (window.Shopify?.captcha?.protect) {
                window.Shopify.captcha.protect(form, () => {
                    form.submit();
                });
            } else {
                form.submit();
            }
        }

        // Dispatch success event
        const successEvent = new CustomEvent('currency:changed', {
            detail: {
                countryCode,
                success: true,
                autoRedirect
            }
        });
        
        window.dispatchEvent(successEvent);

        return {
            success: true,
            countryCode,
            autoRedirect
        };

    } catch (error) {
        console.error('Error setting currency:', error);
        
        // Dispatch error event
        const errorEvent = new CustomEvent('currency:error', {
            detail: {
                error: error.message,
                success: false,
                action: 'setCurrency'
            }
        });
        
        window.dispatchEvent(errorEvent);
        
        return {
            success: false,
            error: error.message
        };
    }
};

/**
 * Get preferred currency from localStorage
 */
export const getPreferredCurrency = () => {
    return localStorage.getItem('preferred_currency');
};

/**
 * Clear preferred currency from localStorage
 */
export const clearPreferredCurrency = () => {
    localStorage.removeItem('preferred_currency');
};

/**
 * Submit currency form with enhanced error handling
 */
export const submitCurrencyForm = async (countryCode, returnTo = '/') => {
    return runSetCurrency(countryCode, {
        autoRedirect: true,
        rememberSelection: true,
        returnTo
    });
};

export default runSetCurrency;
